import { Button, Stack, Tooltip } from "@mui/material";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";

// MUI Icons
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

export default function P2ActionsBtns({
  handleClear,
  handleClearAll,
  handleAutocomplete,
  handleExport,
}) {
  const { t } = useTranslation();
  const clickTimeout = useRef(null);

  const ActionButton = ({ tooltip, onClick, onDoubleClick, icon: Icon }) => (
    <Tooltip title={tooltip}>
      <Button
        variant="contained"
        color="primary"
        onClick={(e) => {
          if (onDoubleClick) {
            clickTimeout.current = setTimeout(() => onClick?.(), 250);
          } else {
            onClick?.();
          }
        }}
        onDoubleClick={(e) => {
          e.preventDefault();
          clearTimeout(clickTimeout.current);
          onDoubleClick?.();
        }}
        sx={{ minWidth: 0, width: 48, height: 48, p: 0 }}
      >
        <Icon />
      </Button>
    </Tooltip>
  );

  return (
    <Stack direction="row" spacing={2} flexWrap="wrap" sx={{ mb: 2 }}>
      <ActionButton
        tooltip={t(
          "Clear assignments with one click.\nDouble click to clear all table"
        )}
        onClick={handleClear}
        onDoubleClick={handleClearAll}
        icon={DeleteOutlineIcon}
      />
      <ActionButton
        tooltip={t("Autocomplete Assignments")}
        onClick={handleAutocomplete}
        icon={AutoFixHighIcon}
      />
      <ActionButton
        tooltip={t("Download as Excel file")}
        onClick={handleExport}
        icon={FileDownloadIcon}
      />
    </Stack>
  );
}
